import "@/App.css";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Process from "@/components/site/Process";
import WhyUs from "@/components/site/WhyUs";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Privacy from "@/components/site/Privacy";
import { Toaster } from "@/components/ui/sonner";

function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ribbon />
        <Services />
        <Manifesto />
        <Process />
        <WhyUs />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <ReactLenis
      root
      options={{ lerp: 0.09, smoothWheel: true, anchors: { offset: -80 } }}
    >
      <div className="App" data-testid="app-root">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
